import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Iframe from "react-iframe";

import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import CloseIcon from "@material-ui/icons/Close";
import { DEFAULT_FOOD_INFO_LINK, DEFAULT_NOT_FOUND } from "../../utils/Urls";
import { RECIPES_URL, PREVENT_CACHE } from "../../utils/Constants";
import { Button } from "@material-ui/core";

const styles = theme => ({
  root: {
    maxWidth: "100%",
    width: "100%",
    height: "100%",
    maxHeight: "100%",
    borderRadius: "10px",
    position: "fixed",
    left: "0px",
    top: "0px",
    margin: "0px"
  },
  DesktopRoot: {
    maxWidth: "450px",
    width: "100%",
    height: "100%",
    maxHeight: "400px",
    borderRadius: "10px",
    position: "relative"
  },
  CustomDesktopRoot: {
    maxWidth: "1000px",
    width: "100%",
    height: "100%",
    maxHeight: "650px",
    borderRadius: "10px",
    position: "relative"
  },
  Header: {
    backgroundColor: "#F0F0F0",
    padding: "10px 20px",
    // position: "sticky",
    top: "0px",
    left: "0px"
  },
  Footer: {
    backgroundColor: "#F0F0F0",
    padding: "10px 20px",
    height: "66px",
    // position: "sticky",
    bottom: "0px",
    left: "0px"
  },
  RemoveMargin: {
    margin: "0px"
  },
  Subheading: {
    fontWeight: "700",
    paddingTop: "10px",
    paddingBottom: "5px"
  },
  VegFlag: {
    position: "relative",
    top: "3px"
  },
  IframeContainer: {
    width: "100%",
    height: "100%",
    "-webkit-overflow-scrolling": "touch",
    overflowY: "auto",
    position: "relative"
  },
  AddToCartBtn: {
    color: "white",
    backgroundColor: "#F37020",
    borderRadius: "50px",
    padding: "0px 30px",
    fontSize: "14px",
    textTransform: "none",
    minHeight: "0px",
    "&:hover": {
      color: "white",
      backgroundColor: "#F37020",
      opacity: "0.9"
    }
  },
  RootDialog: {
    zIndex: "9999"
  }
  // DetailsPanel: {
  // width: "100%",
  // height: "100%",
  // "-webkit-overflow-scrolling":"touch",
  // overflowY:"scroll",
  // },
});

class FoodDetails extends Component {
  constructor(props) {
    super(props);
    // this.state = {
    //   loading: true,
    //   url: ""
    // };

    // if (props.details.url) {
    // this.fetchSite(props.details);
    // } else {
    //   this.state = {
    //     loading: false,
    //     url: props.details.backupUrl || DEFAULT_NOT_FOUND
    //   };
    // }
  }

  fetchSite = details => {
    fetch(details.url, {
      mode: "no-cors",
      headers: {
        "Content-Type": "text/html"
      }
    })
      .then(response => response.text())
      .then(response => {
        console.log(response);
        this.setState({
          loading: false,
          url: details.url
        });
      })
      .catch(err => {
        this.setState({
          loading: false,
          url: details.backupUrl || DEFAULT_NOT_FOUND
        });
      });
  };

  addToCart = () => {
    this.props.handleClose();
    console.log(
      document.getElementById("btn__" + this.props.details.foodid).click()
    );
  };

  render() {
    const {
      classes,
      open,
      details,
      showAdd,
      postFix,
      fullScreen,
      lwMode
    } = this.props;
    const {
      root,
      Header,
      Footer,
      AddToCartBtn,
      RemoveMargin,
      Subheading,
      VegFlag,
      IframeContainer,
      RootDialog,
      DesktopRoot,
      CustomDesktopRoot
    } = classes;

    let urlAddon = postFix === undefined ? PREVENT_CACHE : "";

    return (
      <Dialog
        onClose={this.props.handleClose}
        open={open}
        classes={{
          root: RootDialog,
          paper: fullScreen ? root : lwMode ? CustomDesktopRoot : DesktopRoot
        }}
      >
        <Grid container className={Header}>
          <Grid item xs style={{ fontWeight: "bold" }}>
            {details.foodname}
          </Grid>
          <Grid
            item
            style={{ cursor: "pointer" }}
            onClick={this.props.handleClose}
          >
            <CloseIcon />
          </Grid>
        </Grid>
        {/* <Grid container direction="row" style={{ padding: "10px 20px" }}>
              <Grid item>{details.description}</Grid>
              <Grid item xs>
                <p className={classnames(RemoveMargin, Subheading)}>
                  Allergens
                </p>
                <Grid container justify="flex-start">
                  <Grid item>
                    <img src={Soya} />
                  </Grid>
                  <Grid item>
                    <img src={Nuts} />
                  </Grid>
                  <Grid item>
                    <img src={Cereals} />
                  </Grid>
                  <Grid item>
                    <img src={Celery} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <p className={classnames(RemoveMargin, Subheading)}>
                  Ingredients
                </p>
                <Grid container style={{ padding: "10px", paddingTop: "0px" }}>
                  {Object.keys(details["ingredients"]).map(subTitle => {
                    return (
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <p className={classnames(RemoveMargin, Subheading)}>
                          {subTitle}
                        </p>
                        {details["ingredients"][subTitle].map(item => {
                          return (
                            <div>
                              <img
                                className={VegFlag}
                                src={getIcon(item["vegflag"])}
                                alt="food-type"
                                style={{
                                  paddingLeft:
                                    item["vegflag"] === "N" ? "7px" : "10px"
                                }}
                              />
                              <p
                                className={RemoveMargin}
                                style={{
                                  display: "inline-block",
                                  paddingLeft: "10px",
                                  fontWeight: "0.8rem"
                                }}
                              >
                                {item.label}
                              </p>
                            </div>
                          );
                        })}
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
            </Grid> */}
        <div className={IframeContainer}>
          <Iframe
            url={(details.url || DEFAULT_NOT_FOUND) + urlAddon}
            id="urlFrame"
            // className={DetailsPanel}
            // display="initial"
            // position="relative"
          />
        </div>
        {showAdd && (
          <Grid container className={Footer} justify="flex-end">
            <Button
              variant="contained"
              className={AddToCartBtn}
              disabled={details.disable}
              onClick={this.addToCart}
            >
              Add
            </Button>
          </Grid>
        )}
      </Dialog>
    );
  }
}

export default withStyles(styles)(FoodDetails);



// WEBPACK FOOTER //
// ./src/components/Dashboard/FoodDetails.js